
// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import FormField from 'grommet/components/FormField';
import TextInput from 'grommet/components/TextInput';
import Form from 'grommet/components/Form';
import Section from 'grommet/components/Section';
import Button from 'grommet/components/Button';
import Heading from 'grommet/components/Heading';
import Anchor from 'grommet/components/Anchor';
import MapLocationIcon from 'grommet/components/icons/base/MapLocation';
import { browserHistory as history } from 'react-router';
import constants from '../Constants';
import { saveUserData, registerUser } from '../actions/session';
import Logo from './Logo';

class SignUp extends Component {

    constructor(props) {
        super(props);
        this.registerUser = this.registerUser.bind(this);
        this.chooseLocation = this.chooseLocation.bind(this);
        this.setLocationInfo = this.setLocationInfo.bind(this);
        this.createFormDataModel = this.createFormDataModel.bind(this);
        this.modifyLocation = this.modifyLocation.bind(this);
        this.showRegistrationStatus = this.showRegistrationStatus.bind(this);

        this.state = { busy: false };
    }

    componentDidMount() {
        this.setLocationInfo(this.props.signedUpLocation)
    }

    registerUser(ev) {
        ev.preventDefault();
        const formData = {};
        let isFormValid = true;
        for (const field in this.refs) {
            if ((_.isNull(this.refs[field].value) ||
                _.isUndefined(this.refs[field].value) ||
                this.refs[field].value.trim() === "") && this.refs[field].name !== 'gardenName'
                && this.refs[field].name !== 'gardenLocation') {
                alert("Please fill all the fields");
                isFormValid = false;
                return;
            }
            else
                formData[field] = this.refs[field].value;
        }
        if (isFormValid)
            formData.gardenLocation = this.modifyLocation(formData.gardenLocation);
        this.props.dispatch(registerUser(formData, this.refs.userName.value, this.refs.password.value));

    }

    modifyLocation(location) {
        if (location && location.split(',').length === 2) {
            const cordinates = location.split(',');
            return {
                latitude: cordinates[0],
                longitude: cordinates[1],
            }
        }
        else {
            return ``;
        }
    }

    createFormDataModel() {
        const formData = {};
        for (const field in this.refs) {
            formData[field] = this.refs[field].value;
        }
        return formData;
    }

    chooseLocation() {
        this.props.dispatch(saveUserData(this.createFormDataModel()));
        history.push({
            pathname: constants.ROUTES.CHOOSE_LOCATION,
            // search: '?name=' + sitename_enc,
            state: {
                loggedIn: false
            }
        })
    }

    setLocationInfo() {
        if (!this.props.signedUpLocation || !this.props.signedUpLocation.latitude) {
            return ``;
        }
        else {
            this.refs.gardenLocation.value = `${this.props.signedUpLocation.latitude} , ${this.props.signedUpLocation.longitude}`;
        }
    }



    getInputFieldData(inputField) {
        switch (inputField) {
            case "fullName":
                return this.props.userInfo.fullName = this.props.userInfo && this.props.userInfo.fullName ? this.props.userInfo.fullName : '';
                break;
            case "userName":
                return this.props.userInfo.userName = this.props.userInfo && this.props.userInfo.userName ? this.props.userInfo.userName : '';
                break;
            case "password":
                return this.props.userInfo.password = this.props.userInfo && this.props.userInfo.password ? this.props.userInfo.password : '';
                break;
            case "email":
                return this.props.userInfo.email = this.props.userInfo && this.props.userInfo.email ? this.props.userInfo.email : '';
                break;
            case "gardenName":
                return this.props.userInfo.gardenName = this.props.userInfo && this.props.userInfo.gardenName ? this.props.userInfo.gardenName : '';
                break;
            case "gardenLocaton":
                return this.props.userInfo.gardenLocaton = this.props.userInfo && this.props.userInfo.gardenLocaton ? this.props.userInfo.gardenLocaton : '';
                break;
            default:
                return '';
                break;
        }
    }

    showRegistrationStatus() {
        if (this.props.registrationStatus && this.props.registrationMessage === "success") {
            return (<div className="success">
                User registered successfully. Please login to continue.
                </div>)
        }
        else if (this.props.registrationStatus === false
            && this.props.registrationMessage !== "success") {
            return (<div className="error"> {this.props.registrationMessage} </div>)
        }
        else if (this.props.registrationStatus === null) {
            return (<div className="error">Registeration failed.</div>)
        }
    }

    render() {
        return (
            <Section align="center">
                <Logo size="large" busy={this.state.busy} />
                <form className="register-form" method="post" onSubmit={this.registerUser}>
                        {/*<input type="text" name="fullName" defaultValue={this.getInputFieldData("fullName")} maxLength="96" ref="fullName" placeholder="Full Name" required/>*/}
                        <FormField label={"Username"}>
                          <input type="text" name="userName" defaultValue={this.getInputFieldData("userName")} maxLength="28" ref="userName" placeholder="" required />
                        </FormField>
                        <FormField label={"Password"}>
                          <input type="password" name="password" defaultValue={this.getInputFieldData("password")} maxLength="28" ref="password" placeholder="" required />
                        </FormField>
                        <FormField label={"Email"}>
                          <input type="email" name="email" defaultValue={this.getInputFieldData("email")} maxLength="96" ref="email" placeholder="" required />
                        </FormField>
                  <div>&nbsp;</div>
                        {/*<input type="text" name="gardenName" defaultValue={this.getInputFieldData("gardenName")} maxLength="96" ref="gardenName" placeholder="Site Name"/>*/}
                        {/*<input type="text" name="gardenLocation"  defaultValue={this.getInputFieldData("gardenLocation")} ref="gardenLocation"*/}
                        {/*placeholder="Site Location" className="garden-location-input" onClick={this.chooseLocation} readOnly/>*/}
                        {/* <Button className="garden-location-button" type="button" label={<MapLocationIcon/>} onClick={this.chooseLocation}/> */}
                        <Button type="submit" className="register-button" label='Register'
                            primary={true} />
                </form>
                <div className="signup-nav-section">Already a member ?
                <a className="login-signup-link" href='/login'>Login</a>
                </div>
                {this.showRegistrationStatus()}
            </Section>
        )
    }
}

const select = (state) => ({
    signedUpLocation: state.user.signedUpLocation,
    userInfo: state.user.userInfo,
    registrationStatus: state.session.registrationStatus,
    registrationMessage: state.session.registrationMessage
});

export default connect(select)(SignUp);


// WEBPACK FOOTER //
// ./src/js/components/SignUp.js